import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CartPage from './CartPage';
import { useCart } from '../../../contexts/CartContext';

const CartModal: React.FC = () => {
  const { isCartModalOpen, closeCartModal } = useCart();

  return (
    <Dialog
      open={isCartModalOpen}
      onClose={closeCartModal}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '980px',
          width: '100%',
          margin: { xs: '8px', sm: '16px' },
          maxHeight: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 32px)' },
        },
        '& .MuiDialogTitle-root': {
          paddingRight: '56px',
        },
        '& .MuiDialogContent-root': {
          padding: { xs: '12px', sm: '20px 24px' },
        },
      }}
      fullWidth
    >
      <DialogTitle>
        Кошик оренди
        <IconButton
          aria-label="Закрити"
          onClick={closeCartModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <CartPage />
      </DialogContent>
    </Dialog>
  );
};

export default CartModal;
